import { createFormHook } from '@tanstack/react-form';

import { AutoSaveEffect } from '../components/fields/auto-save-effect';
import { AutoSubmitBlocker } from '../components/fields/auto-submit-blocker';
import { Blocker } from '../components/fields/blocker';
import { CheckboxField } from '../components/fields/checkbox';
import { CheckboxGroup } from '../components/fields/checkbox-group';
import { ClearField } from '../components/fields/clear-field';
import { ColorPickerField } from '../components/fields/color-picker';
import { CurrencyInputField } from '../components/fields/currency-input';
import { DatePickerField } from '../components/fields/date-picker';
import { DialogField } from '../components/fields/dialog';
import { GradientPickerField } from '../components/fields/gradient-picker';
import { InputField } from '../components/fields/input';
import { LabelField } from '../components/fields/label';
import { PopoverField } from '../components/fields/popover';
import { RadioGroup } from '../components/fields/radio-group';
import { ShowIf } from '../components/fields/show-if';
import { SubmitButton } from '../components/fields/submit';
import { SwitchField } from '../components/fields/switch';
import { TextareaField } from '../components/fields/textarea';
import { TimePickerField } from '../components/fields/time-picker';
import { UnsavedChangesIndicator } from '../components/fields/unsaved-changes';
import { ValidationError } from '../components/fields/validation-error';
import { fieldContext, formContext } from '../hooks/use-form-context';

export const { useAppForm, withForm } = createFormHook({
    fieldComponents: {
        AutoSave: AutoSaveEffect,
        CheckboxGroup,
        Checkbox: CheckboxField,
        Clear: ClearField,
        ColorPicker: ColorPickerField,
        Currency: CurrencyInputField,
        DatePicker: DatePickerField,
        GradientPicker: GradientPickerField,
        Input: InputField,
        Label: LabelField,
        Popover: PopoverField,
        RadioGroup,
        Switch: SwitchField,
        Textarea: TextareaField,
        TimePicker: TimePickerField,
        ValidationError,
    },
    formComponents: {
        AutoSubmitBlocker,
        Blocker,
        Dialog: DialogField,
        ShowIf,
        SubmitButton,
        UnsavedChangesIndicator,
    },
    fieldContext,
    formContext,
});
